/**
 * @generated SignedSource<<2e03ef78f994057623f4e9054ab209a9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type connectModelDialogModelColorsQuery$variables = {
  productID: string;
};
export type connectModelDialogModelColorsQuery$data = {
  readonly model: {
    readonly colors: ReadonlyArray<{
      readonly code: string | null;
      readonly colorID: number;
      readonly name: string;
    }>;
    readonly id: string;
    readonly name: string;
    readonly sourceProductTemplateID: number | null;
  } | null;
};
export type connectModelDialogModelColorsQuery = {
  response: connectModelDialogModelColorsQuery$data;
  variables: connectModelDialogModelColorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productID"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "productID"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "model",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceProductTemplateID",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Color",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "connectModelDialogModelColorsQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "connectModelDialogModelColorsQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "275f2a1c0398eb6666a6f3411597e3f6",
    "id": null,
    "metadata": {},
    "name": "connectModelDialogModelColorsQuery",
    "operationKind": "query",
    "text": "query connectModelDialogModelColorsQuery(\n  $productID: ID!\n) {\n  model(id: $productID) {\n    id\n    sourceProductTemplateID\n    name\n    colors {\n      colorID\n      code\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "86a769f3c0de4f073bcde5c7b1c827b4";

export default node;
